import React, { useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  Chip,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem
} from '@mui/material';

// --- FIX: Unify this interface to match the data from the parent page ---
interface Chat {
  id: string;
  title: string;
  updatedAt: string; // Changed from 'timestamp' to 'createdAt'
}

interface PreviousChatsListProps {
  // This now correctly expects chats with a 'createdAt' property
  chats: Chat[];
  onSelectChat: (chatId: string) => void;
  timeFilter: string;
  onTimeFilterChange: (value: string) => void;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
}

// Custom icon for the dropdown
const CustomSelectIcon = (props: any) => {
    return (
        <img
            src="/icons/arrow-down.svg"
            alt="dropdown icon"
            style={{ width: '16px', height: '16px', right: 6, position: 'absolute', pointerEvents: 'none' }}
        />
    );
};

const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat, timeFilter, onTimeFilterChange, searchTerm, onSearchTermChange }) => {

  const timeOptions = [
      { value: 'all', label: 'All' },
      { value: 'today', label: 'Today' },
      { value: 'yesterday', label: 'Yesterday' },
      { value: 'last_7_days', label: 'Last 7 days' },
      { value: 'older', label: 'Older' },
  ];
  
  return (
    <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        
        <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
          Previous Chats ({chats.length})
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => onSearchTermChange(e.target.value)}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><img src="/icons/search_icon.svg" alt="search" style={{ width: 16, height: 16 }} /></InputAdornment>,
                    sx: {
                      fontFamily:'Inter',
                      fontWeight: 400,
                      fontSize: '14px',
                      borderRadius: '8px',
                      bgcolor: '#FFFFFF',
                      width: '215px',
                      height:'32px',
                      '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#E0E0E0'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#0064FF'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#0064FF'
                      }
                    }
                }}
            /> */}

            <FormControl size="small" variant="standard">
                <Select
                    value={timeFilter}
                    onChange={(e) => onTimeFilterChange(e.target.value)}
                    disableUnderline
                    IconComponent={CustomSelectIcon}
                    sx={{
                        fontSize: '12px',
                        fontFamily:'Inter',
                        fontWeight: 500,
                        color: '#333333',
                        height: '32px',
                        width:'auto',
                        borderRadius: '8px',
                        '.MuiSelect-select': {
                            p: '4px 30px 4px 8px',
                            backgroundColor: 'transparent',
                        },
                        border: '1px solid #E0E0E0',
                        
                        '&:hover': {
                            borderColor: '#0064FF',
                        }
                    }}
                >
                    {timeOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
      </Box>
      <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
        {chats.map((chat) => (
          <ListItem key={chat.id} disablePadding>
            <Chip
              label={chat.title}
              onClick={() => onSelectChat(chat.id)}
              variant="outlined"
              sx={{
                cursor: 'pointer',
                bgcolor: 'transparent',
                color: '#333333',
                height: 'auto',
                p: '8px 14px',
                borderRadius: '20px',
                border: '1px dashed #CCCCCC',
                '& .MuiChip-label': {
                  whiteSpace: 'normal',
                  textAlign: 'left',
                },
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                  borderColor: '#B0B8C4'
                }
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default PreviousChatsList;





// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Button,
//   // Popper, // No longer needed
//   // Grow, // No longer needed
//   // Paper, // No longer needed
//   // Divider, // No longer needed
//   // RadioGroup, // No longer needed
//   // FormControlLabel, // No longer needed
//   // Radio, // No longer needed
//   TextField,
//   InputAdornment,
//   FormControl, // Added for the new dropdown
//   Select,      // Added for the new dropdown
//   MenuItem     // Added for the new dropdown
// } from '@mui/material';

// // Interfaces
// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection?: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
//   timeFilter: string;
//   onTimeFilterChange: (value: string) => void;
//   searchTerm: string;
//   onSearchTermChange: (value: string) => void;
// }

// // Custom icon for the dropdown
// const CustomSelectIcon = (props: any) => {
//     return (
//         <img
//             src="/icons/arrow-down.svg"
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px', right: 6, position: 'absolute', pointerEvents: 'none' }}
//         />
//     );
// };

// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat, timeFilter, onTimeFilterChange, searchTerm, onSearchTermChange }) => {

//   const timeOptions = [
//       { value: 'all', label: 'All' },
//       { value: 'today', label: 'Today' },
//       { value: 'yesterday', label: 'Yesterday' },
//       { value: 'this_week', label: 'This Week' }
//   ];
  
//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        
//         {/* Title on the left */}
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>
        
//         {/* Group Search Bar and Filter on the right */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <TextField
//                 variant="outlined"
//                 size="small"
//                 placeholder="Search"
//                 value={searchTerm}
//                 onChange={(e) => onSearchTermChange(e.target.value)}
//                 InputProps={{
//                     startAdornment: <InputAdornment position="start"><img src="/icons/search_icon.svg" alt="search" style={{ width: 16, height: 16 }} /></InputAdornment>,
//                     sx: {
//                       fontFamily:'Inter',
//                       fontWeight: 400,
//                       fontSize: '14px',
//                       borderRadius: '8px',
//                       bgcolor: '#FFFFFF',
//                       width: '215px',
//                       height:'32px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#E0E0E0'
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#0064FF'
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#0064FF'
//                       }
//                     }
//                 }}
//             />

//             {/*--- START: Implemented Dropdown Design ---*/}
//             <FormControl size="small" variant="standard">
//                 <Select
//                     value={timeFilter}
//                     onChange={(e) => onTimeFilterChange(e.target.value)}
//                     disableUnderline
//                     IconComponent={CustomSelectIcon}
//                     sx={{
//                         fontSize: '12px',
//                         fontFamily:'Inter',
//                         fontWeight: 500,
//                         color: '#333333',
//                         height: '32px',
//                         width:'auto',
//                         borderRadius: '8px',
//                         // Styling for the select box itself
//                         '.MuiSelect-select': {
//                             p: '4px 30px 4px 8px', // Adjust padding to accommodate icon
//                             backgroundColor: 'transparent',
//                         },
//                         // Adding a border to match the text field
//                         border: '1px solid #E0E0E0',
                        
//                         '&:hover': {
//                             borderColor: '#0064FF',
//                         }
//                     }}
//                 >
//                     {timeOptions.map((option) => (
//                         <MenuItem key={option.value} value={option.value}>
//                             {option.label}
//                         </MenuItem>
//                     ))}
//                 </Select>
//             </FormControl>
//             {/*--- END: Implemented Dropdown Design ---*/}
//         </Box>
//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;






// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Button,
//   Popper,
//   Grow,
//   Paper,
//   Divider,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   TextField,
//   InputAdornment
// } from '@mui/material';

// // Interfaces
// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection?: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
//   timeFilter: string;
//   onTimeFilterChange: (value: string) => void;
//   searchTerm: string;
//   onSearchTermChange: (value: string) => void;
// }

// // Custom icon for the dropdown trigger button
// const CustomSelectIcon = () => {
//     return (
//         <img
//             src="/icons/arrow-down.svg"
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px' }}
//         />
//     );
// };

// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat, timeFilter, onTimeFilterChange, searchTerm, onSearchTermChange }) => {
//   // --- State Management for the Popper Dropdown ---
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [isTimeRangeOpen, setIsTimeRangeOpen] = useState(false);
//   // Temporary state for selection inside the popper, initialized with the prop value
//   const [tempTimeRangeSelection, setTempTimeRangeSelection] = useState(timeFilter);

//   // Updated time options to include "All"
//   const timeOptions = [
//       { value: 'all', label: 'All' },
//       { value: 'today', label: 'Today' },
//       { value: 'yesterday', label: 'Yesterday' },
//       { value: 'this_week', label: 'This Week' }
//   ];

//   // --- Handlers for the Popper Dropdown ---
//   const handlePopperOpen = (event: React.MouseEvent<HTMLElement>) => {
//       setAnchorEl(event.currentTarget);
//       setIsTimeRangeOpen(true);
//       // Ensure temp state is in sync with the current filter when opening
//       setTempTimeRangeSelection(timeFilter); 
//   };

//   const handlePopperClose = () => {
//       setIsTimeRangeOpen(false);
//       setAnchorEl(null);
//   };

//   const handleClearTimeRange = () => {
//       // Reset temporary selection to 'all'
//       setTempTimeRangeSelection('all');
//   };

//   const handleTimeRangeApply = () => {
//       // Call the parent's handler to apply the change
//       onTimeFilterChange(tempTimeRangeSelection); 
//       handlePopperClose();
//   };
  
//   const selectedLabel = timeOptions.find(opt => opt.value === timeFilter)?.label || 'All';

//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        
//         {/* Title on the left */}
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>
        
//         {/* Group Search Bar and Filter on the right */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <TextField
//                 variant="outlined"
//                 size="small"
//                 placeholder="Search"
//                 value={searchTerm}
//                 onChange={(e) => onSearchTermChange(e.target.value)}
//                 InputProps={{
//                     startAdornment: <InputAdornment position="start"><img src="/icons/search_icon.svg" alt="search" style={{ width: 16, height: 16 }} /></InputAdornment>,
//                     sx: {
//                       fontFamily:'Inter',
//                       fontWeight: 400,
//                       fontSize: '14px', // Slightly larger font to match image
//                       borderRadius: '8px',
//                       bgcolor: '#FFFFFF', // White background
//                       width: '215px', // Fixed width
//                       height:'32px', // Fixed height
//                       '& .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#E0E0E0' // Standard border
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#0064FF'
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#0064FF'
//                       }
//                     }
//                 }}
//             />

//             {/*--- START: Integrated Popper Dropdown (Time Range Filter) ---*/}
//             <div>
//                 <Button
//                     onClick={handlePopperOpen}
//                     endIcon={<CustomSelectIcon />}
//                     variant="outlined" // Added variant for border
//                     sx={{
//                         textTransform: 'none',
//                         fontSize: '14px',
//                         fontWeight: 400,
//                         color: '#333333',
//                         backgroundColor: '#FFFFFF',
//                         borderColor: '#E0E0E0',
//                         borderRadius:'8px',
//                         height: '32px',
//                         width: 'auto',
//                         justifyContent: 'space-between',
//                         '&:hover': {
//                            borderColor: '#0064FF',
//                            backgroundColor: 'transparent'
//                         }
//                     }}
//                 >
//                     {selectedLabel}
//                 </Button>

//                 <Popper
//                     open={isTimeRangeOpen}
//                     anchorEl={anchorEl}
//                     transition
//                     placement="bottom-end"
//                     sx={{ zIndex: 1200 }}
//                 >
//                     {({ TransitionProps }) => (
//                         <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
//                             <Paper sx={{ marginTop: '8px', width: '280px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}}>
//                                 <Typography sx={{ p: '16px 24px 8px 14px', fontFamily: 'Inter', lineHeight:'20px', fontSize: '15px', fontWeight: 600, color: 'rgba(102, 102, 102, 1)' }}>
//                                     Select Time Range
//                                 </Typography>
//                                 <Divider />
//                                 <Box sx={{ py: '8px' }}>
//                                     <RadioGroup value={tempTimeRangeSelection} onChange={(e) => setTempTimeRangeSelection(e.target.value)}>
//                                         {timeOptions.map((option) => (
//                                             <FormControlLabel
//                                                 key={option.value}
//                                                 value={option.value}
//                                                 label={option.label}
//                                                 sx={{
//                                                     m: 0,
//                                                     width: '100%',
//                                                     boxSizing: 'border-box',
//                                                     py: '6px',
//                                                     px: 2,
//                                                     backgroundColor: tempTimeRangeSelection === option.value ? 'rgba(232, 240, 254, 1)' : 'transparent',
//                                                     '& .MuiTypography-root': { fontFamily: 'Inter', fontSize: '16px',fontWeight: 400, color: tempTimeRangeSelection === option.value ? 'text.primary' : 'text.secondary' }
//                                                 }}
//                                                 control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />}
//                                             />
//                                         ))}
//                                     </RadioGroup>
//                                 </Box>
//                                 <Divider />
//                                 <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: '8px' }}>
//                                     <Button onClick={handleClearTimeRange} sx={{ textTransform: 'none', color: 'text.secondary', fontFamily: 'Inter', fontWeight: 500, fontSize: '14px' }}>
//                                         Clear
//                                     </Button>
//                                     <Button onClick={handleTimeRangeApply} sx={{ textTransform: 'none', color: '#0064FF', fontFamily: 'Inter', fontWeight: 500, fontSize: '14px' }}>
//                                         Apply
//                                     </Button>
//                                 </Box>
//                             </Paper>
//                         </Grow>
//                     )}
//                 </Popper>
//             </div>
//             {/*--- END: Integrated Popper Dropdown ---*/}
//         </Box>
//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;




// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Button,
//   Popper,
//   Grow,
//   Paper,
//   Divider,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   TextField, // Import TextField
//   InputAdornment // Import InputAdornment
// } from '@mui/material';

// // Interfaces
// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection?: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
//   timeFilter: string;
//   onTimeFilterChange: (value: string) => void;
//   searchTerm: string; // Add searchTerm prop
//   onSearchTermChange: (value: string) => void; // Add handler prop
// }

// // Custom icon for the dropdown trigger button
// const CustomSelectIcon = () => {
//     return (
//         <img
//             src="/icons/arrow-down.svg"
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px' }}
//         />
//     );
// };

// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat, timeFilter, onTimeFilterChange, searchTerm, onSearchTermChange }) => {
//   // --- State Management for the Popper Dropdown ---
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [isTimeRangeOpen, setIsTimeRangeOpen] = useState(false);
//   // Temporary state for selection inside the popper, initialized with the prop value
//   const [tempTimeRangeSelection, setTempTimeRangeSelection] = useState(timeFilter);

//   const timeOptions = [
//       { value: 'today', label: 'Today' },
//       { value: 'yesterday', label: 'Yesterday' },
//       { value: 'this_week', label: 'This Week' }
//   ];

//   // --- Handlers for the Popper Dropdown ---
//   const handlePopperOpen = (event: React.MouseEvent<HTMLElement>) => {
//       setAnchorEl(event.currentTarget);
//       setIsTimeRangeOpen(true);
//       // Ensure temp state is in sync with the current filter when opening
//       setTempTimeRangeSelection(timeFilter); 
//   };

//   const handlePopperClose = () => {
//       setIsTimeRangeOpen(false);
//       setAnchorEl(null);
//   };

//   const handleClearTimeRange = () => {
//       // Reset temporary selection to a default value, e.g., 'today'
//       setTempTimeRangeSelection('today');
//   };

//   const handleTimeRangeApply = () => {
//       // Call the parent's handler to apply the change
//       onTimeFilterChange(tempTimeRangeSelection); 
//       handlePopperClose();
//   };
  
//   const selectedLabel = timeOptions.find(opt => opt.value === timeFilter)?.label || 'Select Time';

//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         {/* Group Title and Search Bar on the left */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//               Previous Chats ({chats.length})
//             </Typography>
//             <TextField
//                 variant="outlined"
//                 size="small"
//                 placeholder="Search"
//                 value={searchTerm}
//                 onChange={(e) => onSearchTermChange(e.target.value)}
//                 InputProps={{
//                     startAdornment: <InputAdornment position="start"><img src="/icons/search_icon.svg" alt="search" style={{ width: 16, height: 16 }} /></InputAdornment>,
//                     sx: {
//                       fontFamily:'Inter',
//                       fontWeight: 400,
//                       fontSize: '12px',
//                       borderRadius: '8px',
//                       bgcolor: '#F9F9F9',
//                       minWidth: '200px',
//                       flexGrow: 1,
//                       height:'32px',
//                       '& .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#E6E6E6'
//                       },
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#0064FF'
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#0064FF'
//                       }
//                     }
//                 }}
//             />
//         </Box>
        
//         {/*--- START: Integrated Popper Dropdown (Time Range Filter) ---*/}
//         <div>
//             {/* Trigger element styled to look like the original select */}
//             <Button
//                 onClick={handlePopperOpen}
//                 endIcon={<CustomSelectIcon />}
//                 sx={{
//                     textTransform: 'none',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     p: '4px 8px',
//                     color: '#333333',
//                     backgroundColor: 'transparent',
//                 }}
//             >
//                 {selectedLabel}
//             </Button>

//             {/* Popper dropdown menu */}
//             <Popper
//                 open={isTimeRangeOpen}
//                 anchorEl={anchorEl}
//                 transition
//                 placement="bottom-end" // Adjusted for right alignment
//                 sx={{ zIndex: 1200 }}
//             >
//                 {({ TransitionProps }) => (
//                     <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
//                         <Paper sx={{ marginTop: '8px', width: '280px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}}>
//                             <Typography sx={{ p: '16px 24px 8px 14px', fontFamily: 'Inter', lineHeight:'20px', fontSize: '15px', fontWeight: 600, color: 'rgba(102, 102, 102, 1)' }}>
//                                 Select Time Range
//                             </Typography>
//                             <Divider />
//                             <Box sx={{ py: '8px' }}>
//                                 <RadioGroup value={tempTimeRangeSelection} onChange={(e) => setTempTimeRangeSelection(e.target.value)}>
//                                     {timeOptions.map((option) => (
//                                         <FormControlLabel
//                                             key={option.value}
//                                             value={option.value}
//                                             label={option.label}
//                                             sx={{
//                                                 m: 0,
//                                                 width: '100%',
//                                                 boxSizing: 'border-box',
//                                                 py: '6px',
//                                                 px: 2,
//                                                 backgroundColor: tempTimeRangeSelection === option.value ? 'rgba(232, 240, 254, 1)' : 'transparent',
//                                                 '& .MuiTypography-root': { fontFamily: 'Inter', fontSize: '16px',fontWeight: 400, color: tempTimeRangeSelection === option.value ? 'text.primary' : 'text.secondary' }
//                                             }}
//                                             control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />}
//                                         />
//                                     ))}
//                                 </RadioGroup>
//                             </Box>
//                             <Divider />
//                             <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: '8px' }}>
//                                 <Button onClick={handleClearTimeRange} sx={{ textTransform: 'none', color: 'text.secondary', fontFamily: 'Inter', fontWeight: 500, fontSize: '14px' }}>
//                                     Clear
//                                 </Button>
//                                 <Button onClick={handleTimeRangeApply} sx={{ textTransform: 'none', color: '#0064FF', fontFamily: 'Inter', fontWeight: 500, fontSize: '14px' }}>
//                                     Apply
//                                 </Button>
//                             </Box>
//                         </Paper>
//                     </Grow>
//                 )}
//             </Popper>
//         </div>
//         {/*--- END: Integrated Popper Dropdown ---*/}

//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;




// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   // Imports for the new dropdown
//   Button,
//   Popper,
//   Grow,
//   Paper,
//   Divider,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from '@mui/material';

// // Interfaces
// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection?: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
//   timeFilter: string;
//   onTimeFilterChange: (value: string) => void;
// }

// // Custom icon for the dropdown trigger button
// const CustomSelectIcon = () => {
//     return (
//         <img
//             src="/icons/arrow-down.svg"
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px' }}
//         />
//     );
// };

// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat, timeFilter, onTimeFilterChange }) => {
//   // --- State Management for the Popper Dropdown ---
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [isTimeRangeOpen, setIsTimeRangeOpen] = useState(false);
//   // Temporary state for selection inside the popper, initialized with the prop value
//   const [tempTimeRangeSelection, setTempTimeRangeSelection] = useState(timeFilter);

//   const timeOptions = [
//       { value: 'today', label: 'Today' },
//       { value: 'yesterday', label: 'Yesterday' },
//       { value: 'this_week', label: 'This Week' }
//   ];

//   // --- Handlers for the Popper Dropdown ---
//   const handlePopperOpen = (event: React.MouseEvent<HTMLElement>) => {
//       setAnchorEl(event.currentTarget);
//       setIsTimeRangeOpen(true);
//       // Ensure temp state is in sync with the current filter when opening
//       setTempTimeRangeSelection(timeFilter); 
//   };

//   const handlePopperClose = () => {
//       setIsTimeRangeOpen(false);
//       setAnchorEl(null);
//   };

//   const handleClearTimeRange = () => {
//       // Reset temporary selection to a default value, e.g., 'today'
//       setTempTimeRangeSelection('today');
//   };

//   const handleTimeRangeApply = () => {
//       // Call the parent's handler to apply the change
//       onTimeFilterChange(tempTimeRangeSelection); 
//       handlePopperClose();
//   };
  
//   const selectedLabel = timeOptions.find(opt => opt.value === timeFilter)?.label || 'Select Time';

//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>

//         {/*--- START: Integrated Popper Dropdown ---*/}
//         <div>
//             {/* Trigger element styled to look like the original select */}
//             <Button
//                 onClick={handlePopperOpen}
//                 endIcon={<CustomSelectIcon />}
//                 sx={{
//                     textTransform: 'none',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     p: '4px 8px',
//                     color: '#333333',
//                     backgroundColor: 'transparent',
//                 }}
//             >
//                 {selectedLabel}
//             </Button>

//             {/* Popper dropdown menu */}
//             <Popper
//                 open={isTimeRangeOpen}
//                 anchorEl={anchorEl}
//                 transition
//                 placement="bottom-end" // Adjusted for right alignment
//                 sx={{ zIndex: 1200 }}
//             >
//                 {({ TransitionProps }) => (
//                     <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
//                         <Paper sx={{ marginTop: '8px', width: '280px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}}>
//                             <Typography sx={{ p: '16px 24px 8px 14px', fontFamily: 'Inter', lineHeight:'20px', fontSize: '15px', fontWeight: 600, color: 'rgba(102, 102, 102, 1)' }}>
//                                 Select Time Range
//                             </Typography>
//                             <Divider />
//                             <Box sx={{ py: '8px' }}>
//                                 <RadioGroup value={tempTimeRangeSelection} onChange={(e) => setTempTimeRangeSelection(e.target.value)}>
//                                     {timeOptions.map((option) => (
//                                         <FormControlLabel
//                                             key={option.value}
//                                             value={option.value}
//                                             label={option.label}
//                                             sx={{
//                                                 m: 0,
//                                                 width: '100%',
//                                                 boxSizing: 'border-box',
//                                                 py: '6px',
//                                                 px: 2,
//                                                 backgroundColor: tempTimeRangeSelection === option.value ? 'rgba(232, 240, 254, 1)' : 'transparent',
//                                                 '& .MuiTypography-root': { fontFamily: 'Inter', fontSize: '16px',fontWeight: 400, color: tempTimeRangeSelection === option.value ? 'text.primary' : 'text.secondary' }
//                                             }}
//                                             control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />}
//                                         />
//                                     ))}
//                                 </RadioGroup>
//                             </Box>
//                             <Divider />
//                             <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: '8px' }}>
//                                 <Button onClick={handleClearTimeRange} sx={{ textTransform: 'none', color: 'text.secondary', fontFamily: 'Inter', fontWeight: 500, fontSize: '14px' }}>
//                                     Clear
//                                 </Button>
//                                 <Button onClick={handleTimeRangeApply} sx={{ textTransform: 'none', color: '#0064FF', fontFamily: 'Inter', fontWeight: 500, fontSize: '14px' }}>
//                                     Apply
//                                 </Button>
//                             </Box>
//                         </Paper>
//                     </Grow>
//                 )}
//             </Popper>
//         </div>
//         {/*--- END: Integrated Popper Dropdown ---*/}

//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;




// import React from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Select,
//   MenuItem,
//   FormControl,
// } from '@mui/material';

// // Interfaces
// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection?: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
//   timeFilter: string;
//   onTimeFilterChange: (value: string) => void;
// }

// const CustomSelectIcon = (props: any) => {
//     return (
//         <img
//             src="/icons/arrow-down.svg"
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px', right: 6, position: 'absolute', pointerEvents: 'none' }}
//         />
//     );
// };

// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat, timeFilter, onTimeFilterChange }) => {
//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>
//         <FormControl size="small" variant="standard">
//           <Select
//             value={timeFilter}
//             onChange={(e) => onTimeFilterChange(e.target.value)}
//             disableUnderline
//             IconComponent={CustomSelectIcon}
//             sx={{
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 '.MuiSelect-select': {
//                     p: '4px 8px',
//                 },
//             }}
//           >
//             <MenuItem value="today">Today</MenuItem>
//             <MenuItem value="yesterday">Yesterday</MenuItem>
//             <MenuItem value="this_week">This Week</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;



// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Select,
//   MenuItem,
//   FormControl,
// } from '@mui/material';
// import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';

// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection?: string; // Made optional as it's not in the API response
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
// }
// const CustomSelectIcon = (props: any) => {
//     return (
//         <img
//             src="/icons/arrow-down.svg" // Your custom icon path
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px', right: 6, position: 'absolute', pointerEvents: 'none' }}
//         />
//     );
// };
// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat }) => {
//   const [timeFilter, setTimeFilter] = useState('today');

//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>
//         <FormControl size="small" variant="standard">
//           <Select
//             value={timeFilter}
//             onChange={(e) => setTimeFilter(e.target.value)}
//             disableUnderline
//             IconComponent={CustomSelectIcon}
//             sx={{
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 '.MuiSelect-select': {
//                     p: '4px 8px',
//                 },
//             }}
//           >
//             <MenuItem value="today">Today</MenuItem>
//             <MenuItem value="yesterday">Yesterday</MenuItem>
//             <MenuItem value="this_week">This Week</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;




// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Select,
//   MenuItem,
//   FormControl,
// } from '@mui/material';
// import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';

// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
// }
// const CustomSelectIcon = (props: any) => {
//     return (
//         <img
//             src="/icons/arrow-down.svg" // Your custom icon path
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px', right: 6, position: 'absolute', pointerEvents: 'none' }}
//         />
//     );
// };
// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat }) => {
//   const [timeFilter, setTimeFilter] = useState('today');

//   return (
//     <Box sx={{ mt: 4, width: '656px', mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', color:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>
//         <FormControl size="small" variant="standard">
//           <Select
//             value={timeFilter}
//             onChange={(e) => setTimeFilter(e.target.value)}
//             disableUnderline
//             IconComponent={CustomSelectIcon}
//             sx={{
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 '.MuiSelect-select': {
//                     p: '4px 8px',
//                 },
//             }}
//           >
//             <MenuItem value="today">Today</MenuItem>
//             <MenuItem value="yesterday">Yesterday</MenuItem>
//             <MenuItem value="this_week">This Week</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.75 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               variant="outlined"
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: 'transparent',
//                 color: '#333333',
//                 height: 'auto',
//                 p: '8px 14px',
//                 borderRadius: '20px',
//                 border: '1px dashed #CCCCCC',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: 'rgba(0, 0, 0, 0.04)',
//                   borderColor: '#B0B8C4'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;




// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   List,
//   ListItem,
//   Chip,
//   Select,
//   MenuItem,
//   FormControl,
// } from '@mui/material';
// import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';

// interface Chat {
//   id: string;
//   title: string;
//   timestamp: string;
//   connection: string;
// }

// interface PreviousChatsListProps {
//   chats: Chat[];
//   onSelectChat: (chatId: string) => void;
// }
// const CustomSelectIcon = (props: any) => {
//     return (
//         <img
//             src="/icons/arrow-down.svg" // Your custom icon path
//             alt="dropdown icon"
//             style={{ width: '16px', height: '16px', right: 6, position: 'absolute', pointerEvents: 'none' }}
//         />
//     );
// };
// const PreviousChatsList: React.FC<PreviousChatsListProps> = ({ chats, onSelectChat }) => {
//   const [timeFilter, setTimeFilter] = useState('today');

//   return (
//     <Box sx={{ mt: 4, width: '100%', maxWidth: 800, mx: 'auto' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography sx={{ fontFamily:'Inter', fontSize:'14px', fontColor:'#333333', fontWeight: 500 }}>
//           Previous Chats ({chats.length})
//         </Typography>
//         <FormControl size="small" variant="standard">
//           <Select
//             value={timeFilter}
//             onChange={(e) => setTimeFilter(e.target.value)}
//             disableUnderline
//             IconComponent={CustomSelectIcon}
//             sx={{
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 '.MuiSelect-select': {
//                     p: '4px 8px',
//                 },
//             }}
//           >
//             <MenuItem value="today">Today</MenuItem>
//             <MenuItem value="yesterday">Yesterday</MenuItem>
//             <MenuItem value="this_week">This Week</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//       <List sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
//         {chats.map((chat) => (
//           <ListItem key={chat.id} disablePadding>
//             <Chip
//               label={chat.title}
//               onClick={() => onSelectChat(chat.id)}
//               sx={{
//                 cursor: 'pointer',
//                 bgcolor: '#f0f2f5',
//                 color: 'text.primary',
//                 height: 'auto',
//                 p: '10px 16px',
//                 borderRadius: '20px',
//                 '& .MuiChip-label': {
//                   whiteSpace: 'normal',
//                   textAlign: 'left',
//                 },
//                 '&:hover': {
//                   bgcolor: '#e4e6e9'
//                 }
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default PreviousChatsList;
